import React from "react";
import { twMerge } from "tailwind-merge";


export function Logo({ className }) {
    return (
        <img src="/assets/img/logo-mfl.png" alt="app logo" className={twMerge('w-full max-w-52 py-2 cursor-pointer drop-shadow-md', className)} />
    );
}